import {all, call, put, takeEvery} from 'redux-saga/effects';
import {sharedCommonActions} from '../../common/redux/SharedCommonActions';
import {getErrorMessage, logger} from '../../core/services/LogService';
import ProcessingModel from '../models/ProcessingModel';
import ProcessingType from '../models/ProcessingType';
import sharedProcessingsService from '../services/SharedProcessingsService';
import {
  GET_PROCESSING_CONFIG,
  sharedProcessingActions,
} from './SharedProcessingActions';

export function* sharedProcessingSagas() {
  yield all([takeEvery(GET_PROCESSING_CONFIG, getProcessingConfig)]);
}

function* getProcessingConfig() {
  try {
    logger.debug('Start getting processing config');
    yield put(sharedCommonActions.fetchStart('getProcessingConfig'));

    const config: {[key in ProcessingType]?: ProcessingModel} = yield call(
      sharedProcessingsService.getProcessingsConfig.bind(
        sharedProcessingsService,
      ),
    );
    logger.debug('Processing config fetched');
    yield put(sharedProcessingActions.getProcessingConfigSuccess(config));
    yield put(sharedCommonActions.fetchSuccess('getProcessingConfig'));
  } catch (error: any) {
    logger.error(
      `Error while getting processing config: ${getErrorMessage(error)}`,
    );
    logger.error(error);
    yield put(
      sharedCommonActions.fetchError('getProcessingConfig', error as string),
    );
  }
}
